import { useEffect, useState } from "react";
import { database } from "../../firebaseConfig";
import { ref, onValue } from "firebase/database";

// Subscribes to /World/{userId}/copyClones and returns a sorted array.
// Returns { clones, loading } — never null.
export const useCopyClones = (userId) => {
  const [clones, setClones] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setClones([]);
      setLoading(false);
      return;
    }
    const clonesRef = ref(database, `/World/${userId}/copyClones`);
    const unsub = onValue(clonesRef, (snap) => {
      const val = snap.val() || {};
      const list = Object.entries(val).map(([id, data]) => ({ id, ...data }));
      // Newest first
      list.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
      setClones(list);
      setLoading(false);
    });
    return () => unsub();
  }, [userId]);

  return { clones, loading };
};

export const useCopyClone = (userId, cloneId) => {
  const [clone, setClone] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId || !cloneId) {
      setClone(null);
      setLoading(false);
      return;
    }
    const cloneRef = ref(database, `/World/${userId}/copyClones/${cloneId}`);
    const unsub = onValue(cloneRef, (snap) => {
      if (!snap.exists()) {
        setClone(null);
      } else {
        setClone({ id: cloneId, ...snap.val() });
      }
      setLoading(false);
    });
    return () => unsub();
  }, [userId, cloneId]);

  return { clone, loading };
};
